import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SignIn, MagnifyingGlass } from "@phosphor-icons/react";

function fmt(dt) {
  if (!dt) return "";
  try { return new Date(dt).toLocaleString("fr-FR"); } catch { return dt; }
}

export default function AdminActivity() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/activity").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-muted font-mono text-sm animate-pulse">Chargement…</div>;

  return (
    <div data-testid="admin-activity">
      <div className="overline mb-2">Suivi de l'usage</div>
      <h1 className="font-display text-3xl font-bold mb-8">Journal d'activité</h1>

      <div className="grid lg:grid-cols-2 gap-6">
        <div>
          <div className="overline mb-3 flex items-center gap-2"><SignIn size={14} className="text-accent" /> Dernières connexions ({data.logins.length})</div>
          <div className="surface rounded-lg divide-y divide-border" data-testid="activity-logins">
            {data.logins.length === 0 ? (
              <div className="p-5 text-sm text-muted">Aucune connexion enregistrée.</div>
            ) : data.logins.map((l, i) => (
              <div key={i} className="p-4 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-sm text-fg truncate">{l.name || l.email}</div>
                  <div className="text-xs text-muted font-mono truncate">{l.email}</div>
                </div>
                <div className="text-xs text-muted font-mono shrink-0">{fmt(l.at)}</div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="overline mb-3 flex items-center gap-2"><MagnifyingGlass size={14} className="text-accent" /> Dernières recherches ({data.searches.length})</div>
          <div className="surface rounded-lg divide-y divide-border" data-testid="activity-searches">
            {data.searches.length === 0 ? (
              <div className="p-5 text-sm text-muted">Aucune recherche enregistrée.</div>
            ) : data.searches.map((s, i) => (
              <div key={i} className="p-4">
                <div className="text-sm text-fg line-clamp-2">{s.query}</div>
                <div className="text-xs text-muted font-mono mt-1 flex items-center justify-between gap-3">
                  <span className="truncate">{s.email}</span>
                  <span className="shrink-0">{fmt(s.at)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
